<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title" id="int"><a id="page_5"></a><span class="bold">Introduction</span></h2>
<p class="noindent">This book looks at the development of air fighting on the Western Front in the Great War and the pilots who fought it, from its first tentative beginnings to the emergence of the fighter ‘aces’. Everything was new and untried. It was up to the airmen of the day to gain experience, develop tactics and try to survive, in flimsy aeroplanes and with no parachutes.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Introduction.vue?603e2d88